import { Customer } from "@farmact/model/src/model/Customer";
import { query, where } from "firebase/firestore";
import { Firebase } from "../../../index";

export function getQueryForCustomersWithIds(customerIds: Customer["id"][]) {
    return query(Firebase.instance().getAllCustomers(), where("id", "in", customerIds));
}
